function getContent() {
    return new Promise(function (resolve, reject) {

        var url = "https://www.parksproject.us/collections/all?sort_by=best-selling"
        $.ajax({
            url: url,
            success: function (data) {
                resolve(data);
            },
            error: function (err) {
                reject(err);
            }
        });
    });

}